// На страницу выводим три поля:

//       "Количество сделок с THE KEYS"
// Здесь считаем все сделки с типом "Успех" у клиента

//       "Всего вы заработали с THE KEYS"
// Здесь выводим сумму поля Сделка.ОбщийДоход со всех сделок, где клиент выступал, как продавец или бенефициар-продавец

//       "Средний годовой доход с THE KEYS"
// Здесь выводим средний годовой процент по всем сделкам где клиент выступал, как продавец или бенефициар-продавец. Складываем все годовые проценты и делим на количество сделок (среднее арифмитическое)

import { BasePageLayout, ConfigurationContext } from '@kirz/mui-admin';
import { TrendingUp, AccountBalance, Percent } from '@mui/icons-material';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  styled,
} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';

import { UserContext } from 'contexts';

const MetricCard = styled(Card)(({ theme }) => ({
  height: '100%',
  borderRadius: 16,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
}));

const MetricIcon = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: 12,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
}));

export function TotalIncome() {
  const { user } = useContext(UserContext);
  const { hasura } = useContext(ConfigurationContext);
  const [totalDeals, setTotalDeals] = useState<number | null>(null);
  const [income, setIncome] = useState<number | null>(null);
  const [yearlyIncome, setYearlyIncome] = useState<number | null>(null);

  useEffect(() => {
    (async () => {
      const [{ dealAggregate, sellingDeals }] = await Promise.all([
        hasura.request({
          type: 'custom',
          query: `
            {
              dealAggregate {
                aggregate {
                  count
                }
              }
              sellingDeals: deal(where: {_or: [
                {sellerId: {_eq: ${user.id}}}, 
                {clients: {
                  clientId:{_eq: ${user.id}},
                  role: {_eq: "beneficiary"},
                  type: {_eq: "seller"}
                }}
              ]}) {
                price {
                  totalIncome
                  yearlyIncome
                }
              }
            }
          `,
          variables: {},
        }),
      ]);

      setTotalDeals(dealAggregate.aggregate.count);
      setIncome(
        sellingDeals
          .map((deal: any) => deal.price.totalIncome || 0)
          .reduce((a: number, b: number) => a + b, 0),
      );
      setYearlyIncome(
        sellingDeals.length > 0
          ? sellingDeals
              .map((deal: any) => deal.price.yearlyIncome || 0)
              .reduce((a: number, b: number) => a + b, 0) / sellingDeals.length
          : 0,
      );
    })();
  }, [hasura, user]);

  return (
    <BasePageLayout
      title="Общая доходность"
      paperProps={{
        sx: {
          p: { xs: 2, sm: 3 },
          minHeight: '100vh',
          backgroundColor: 'transparent',
        },
        elevation: 0,
      }}
    >
      <Box sx={{ maxWidth: 600, mx: 'auto' }}>
        <Grid container spacing={3}>
          {/* Количество сделок с THE KEYS */}
          <Grid item xs={12}>
            <MetricCard>
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <MetricIcon
                  sx={{ backgroundColor: '#e3f2fd', color: '#1976d2' }}
                >
                  <TrendingUp />
                </MetricIcon>
                <Typography
                  variant="h4"
                  component="div"
                  sx={{ fontWeight: 'bold', mb: 1, fontSize: '24px' }}
                >
                  {totalDeals ?? ' '}
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ whiteSpace: 'pre-line' }}
                >
                  Количество сделок{'\n'}с THE KEYS
                </Typography>
              </CardContent>
            </MetricCard>
          </Grid>

          {/* Всего вы заработали с THE KEYS */}
          <Grid item xs={12}>
            <MetricCard>
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <MetricIcon
                  sx={{ backgroundColor: '#e8f5e8', color: '#2e7d32' }}
                >
                  <AccountBalance />
                </MetricIcon>
                <Typography
                  variant="h4"
                  component="div"
                  sx={{ fontWeight: 'bold', mb: 1, fontSize: '24px' }}
                >
                  ₽{(income ?? 0).toLocaleString()}
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ whiteSpace: 'pre-line' }}
                >
                  Всего вы заработали{'\n'}с THE KEYS
                </Typography>
              </CardContent>
            </MetricCard>
          </Grid>

          {/* Средний годовой доход с THE KEYS */}
          <Grid item xs={12}>
            <MetricCard>
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <MetricIcon
                  sx={{ backgroundColor: '#fff3e0', color: '#f57c00' }}
                >
                  <Percent />
                </MetricIcon>
                <Typography
                  variant="h4"
                  component="div"
                  sx={{ fontWeight: 'bold', mb: 1, fontSize: '24px' }}
                >
                  {yearlyIncome == null ? ' ' : yearlyIncome.toFixed(1)}%
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ whiteSpace: 'pre-line' }}
                >
                  Средний годовой доход{'\n'}с THE KEYS
                </Typography>
              </CardContent>
            </MetricCard>
          </Grid>
        </Grid>
      </Box>
    </BasePageLayout>
  );
}
